import { ExclamationCircleFilled, LoadingOutlined } from '@ant-design/icons'
import { useFormatter } from '@api/useFormatter'
import { addCommasToNumber, BBDTag, Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import api from '@utils/api'
import classNames from 'classnames'
import React, { useEffect, useState } from 'react'

import { useDirectiveContext } from '../DirectiveContext'

export function PriceExpand({ directive, resizeRow, addPricesToRow }) {
  const { selectedDate } = useDirectiveContext()
  const [isLoading, setIsLoading] = useState(true)

  const { formatCurrency } = useFormatter()
  const formattedCurrency = formatCurrency(null, true)

  useEffect(() => {
    if (directive.prices) {
      setIsLoading(false)
    } else {
      api
        .getDailyDirectivePrices({}, selectedDate.toISOString(), directive.curve_group_id)
        .then((resp) => {
          addPricesToRow(directive, resp.data)
          setIsLoading(false)
        })
        .catch((e) => {
          addPricesToRow(directive, [])
          setIsLoading(false)
        })
    }
  }, [])
  useEffect(() => {
    resizeRow()
  }, [isLoading])
  if (isLoading)
    return (
      <Horizontal horizontalCenter verticalCenter className='p-3'>
        <Texto category='h6' appearance='secondary'>
          <LoadingOutlined className='mr-3' />
          Loading Prices
        </Texto>
      </Horizontal>
    )
  if (!isLoading && directive.prices?.length === 0) {
    return (
      <Horizontal horizontalCenter verticalCenter className='p-3'>
        <Texto category='h6' appearance='error'>
          <ExclamationCircleFilled className='mr-3' />
          No Active Prices
        </Texto>
      </Horizontal>
    )
  }
  return (
    <Vertical>
      <Vertical>
        <DirectivePriceHeader />
        {directive.prices?.map((price, i) => (
          <DirectivePriceRow directive={directive} price={price} key={i} formattedCurrency={formattedCurrency} />
        ))}
      </Vertical>
    </Vertical>
  )
}

function DirectivePriceHeader() {
  return (
    <Horizontal className='py-2 px-3 bg-2'>
      <Vertical flex={2}>
        <Texto category='label' weight={600} appearance='medium'>
          TERMINAL
        </Texto>
      </Vertical>
      <Vertical flex={2}>
        <Texto category='label' weight={600} appearance='medium'>
          PRODUCT
        </Texto>
      </Vertical>
      <Vertical flex={1}>
        <Texto category='label' weight={600} align='right' appearance='medium'>
          LOADED
        </Texto>
      </Vertical>
      <Vertical flex={1}>
        <Texto category='label' weight={600} align='right' appearance='medium'>
          SCHEDULED
        </Texto>
      </Vertical>
      <Vertical flex={1}>
        <Texto category='label' weight={600} align='right' appearance='medium'>
          PLANNED
        </Texto>
      </Vertical>
      <Vertical style={{ maxWidth: 50 }} />
      <Vertical flex={2}>
        <Texto category='label' weight={600} appearance='medium'>
          PRICE
        </Texto>
      </Vertical>
    </Horizontal>
  )
}
function DirectivePriceRow({ price, directive, formattedCurrency }) {
  const { selectedPrice, setSelectedPrice, setSelectedDirective } = useDirectiveContext()
  const handleSelect = () => {
    setSelectedDirective(directive)
    setSelectedPrice(price)
  }

  return (
    <div
      onClick={handleSelect}
      className={classNames('flex py-2 px-3 bg-1 border-bottom directive-price-row', {
        selected: price.curve_id === selectedPrice?.curve_id || price.id,
      })}
    >
      <Vertical flex={2}>
        <Texto>{price.terminal}</Texto>
      </Vertical>
      <Vertical flex={2}>
        <Texto>{price.product}</Texto>
      </Vertical>
      <Vertical flex={1}>
        <Texto weight={price.loaded === 0 ? 500 : 'bold'} align='right'>
          {addCommasToNumber(price.loaded)}
        </Texto>
      </Vertical>
      <Vertical flex={1}>
        <Texto align='right'> {addCommasToNumber(price.scheduled)}</Texto>
      </Vertical>
      <Vertical flex={1}>
        <Texto align='right'> {addCommasToNumber(price.planned)}</Texto>
      </Vertical>
      <Vertical style={{ maxWidth: 50 }} />
      <Vertical flex={2}>
        <BBDTag success={price.is_low} error={!price.is_low} className='flex justify-center' style={{ maxWidth: 120 }}>
          {formattedCurrency}
          {price.price}
          <Texto appearance={price.is_low ? 'success' : 'error'} className='pl-2' category='label'>
            {price.price_difference ? `(${price.price_difference})` : '(Low Price)'}
          </Texto>
        </BBDTag>
      </Vertical>
    </div>
  )
}
